import React, { useState, useEffect } from 'react'
import Header from '../Utilities/HeaderInner'
import Footer from '../Utilities/Footer'
import m2 from "../Images/Products/MURINE-XT MOCK A.png"
import m3 from "../Images/Products/MURINE-XT MOCK B.png"
import d1 from "../Images/Homepage/dosage.png"
import d2 from "../Images/Homepage/instructions.png"
import d3 from "../Images/Homepage/storage.png"
import d4 from "../Images/Homepage/noname.png"
import i1 from "../Images/Homepage/indications/cardiovascular health.jpg"
import i2 from "../Images/Homepage/indications/oncological health.jpg"
import i3 from "../Images/Homepage/indications/neurological health.jpg"
import i4 from "../Images/Homepage/indications/gynaecological health.jpg"
import i5 from "../Images/Homepage/indications/general surgeon.jpg"
import i6 from "../Images/Homepage/indications/opthamology.jpg"
import ReadMoreArea from '@foxeian/react-read-more';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Link } from 'react-router-dom'

const MurineXT = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

  }, []);

  // mechanism of action

  const [cardiovascular, setCardiovascular] = useState(true);
  const [gynaecology, setGynaecology] = useState(false);
  const [oncology, setOncology] = useState(false);
  const [ophthalmology, setophthalmology] = useState(false);
  const [surgery, setSurgery] = useState(false);

  const [activeClass1, setActiveClass1] = useState("active")
  const [activeClass2, setActiveClass2] = useState("")
  const [activeClass3, setActiveClass3] = useState("")
  const [activeClass4, setActiveClass4] = useState("")
  const [activeClass5, setActiveClass5] = useState("")

  const showProduct = (e) => {
    const text = e.target.innerText;
    setActiveClass1("");
    setActiveClass2("");
    setActiveClass3("");
    setActiveClass4("");
    setActiveClass5("");

    if (text == "Cardiovascular Health") {
      setCardiovascular(true);
      setGynaecology(false);
      setOncology(false);
      setophthalmology(false);
      setSurgery(false);
      setActiveClass1("active");
    } else if (text == "Gynaecology") {
      setCardiovascular(false);
      setGynaecology(true);
      setOncology(false);
      setophthalmology(false);
      setSurgery(false);
      setActiveClass2("active");
    } else if (text == "Oncology") {
      setCardiovascular(false);
      setGynaecology(false);
      setOncology(true);
      setophthalmology(false);
      setSurgery(false);
      setActiveClass3("active");
    } else if (text == "General Surgery") {
      setCardiovascular(false);
      setGynaecology(false);
      setOncology(false);
      setophthalmology(false);
      setSurgery(true);
      setActiveClass4("active");
    } else if (text == "Macular Degeneration (Ophthalmology)") {
      setCardiovascular(false);
      setGynaecology(false);
      setOncology(false);
      setophthalmology(true);
      setSurgery(false);
      setActiveClass5("active");
    }

  }

  const buttonStyle = {
    color: "#e16a3d",
    fontSize: "16px",
    // Add any other CSS styles as needed
  };

  const responsive = {
    0: { items: 1 }
  };

  const items = [
    <div className="mechanism-option-body cardiovascular">
      <h3>Cardiovascular Health</h3>
      <div className="mechanism-card">
        <h4>Ubiquinone (cardiovascular Q10)</h4>
        <p>Enhances cellular energy production
          and supports heart function by improving blood vessel health and
          reducing oxidative stress. It helps in managing blood pressure and
          improving overall cardiovascular performance.</p>
      </div>

      <div className="mechanism-card">
        <h4>Lycopene</h4>
        <p>Provides antioxidant protection to the cardiovascular
          system, reducing the risk of heart disease by neutralizing harmful free
          radicals and supporting healthy blood vessel function.
        </p>
      </div>


      <div className="mechanism-card">
        <h4>Omega-3 Fatty Acids (EPA & DHA)</h4>
        <p>Essential for reducing
          inflammation and supporting healthy cholesterol levels, omega-3s
          contribute to heart health by lowering triglycerides and improving
          arterial function.

        </p>
      </div>
    </div>,
    <div className="mechanism-option-body gynaecology">
      <h3>Gynaecology</h3>
      <div className="mechanism-card">
        <h4>Wheat Germ Oil</h4>
        <p> Rich in vitamin E and essential fatty acids, the oil
          supports skin health and overall reproductive well-being and also
          helps in hormonal balance and providing vital nutrients during
          pregnancy.</p>
      </div>

      <div className="mechanism-card">
        <h4>Vitamin B12</h4>
        <p> Important for cellular function and energy production,
          supporting overall reproductive health and managing symptoms
          related to hormonal changes.
        </p>
      </div>
      <div className="mechanism-card">
        <h4>ubiquinone (cardiovascular Q10)</h4>
        <p>Protects neuronal cells from oxidative
          damage and supports mitochondrial function, potentially reducing
          the risk of neurodegenerative diseases such as Parkinson’s and
          Alzheimer’s.
        </p>
      </div>

      <div className="mechanism-card">
        <h4>Omega-3 Fatty Acids (EPA & DHA)</h4>
        <p>Contribute to brain health by
          supporting cognitive function, reducing inflammation, and protecting
          against neurodegeneration.
        </p>
      </div>
    </div>,
    <div className="mechanism-option-body oncology">
      <h3>Oncology</h3>
      <div className="mechanism-card">
        <h4>Lycopene</h4>
        <p>Known for its potential role in cancer prevention,
          particularly prostate cancer, by reducing oxidative stress and
          inhibiting cancer cell proliferation.
        </p>
      </div>

      <div className="mechanism-card">
        <h4>Selenium</h4>
        <p>Acts as an antioxidant, potentially reducing the risk of
          cancer and supporting the body’s natural defence mechanisms.
        </p>
      </div>
    </div>,
    <div className="mechanism-option-body oncology">
      <h3>General Surgery</h3>
      <div className="mechanism-card">
        <h4>Calcium Ascorbate</h4>
        <p>Supports wound healing and recovery by
          enhancing collagen synthesis and immune function, crucial for postsurgical repair and overall recovery.</p>
      </div>

      <div className="mechanism-card">
        <h4>Zinc</h4>
        <p>Essential for cellular repair and immune function, helping in
          faster recovery and reducing the risk of post-surgical complications.</p>
      </div>
    </div>,
    <div className="mechanism-option-body oncology">
      <h3>Macular Degenration (Ophthalmology)</h3>
      <div className="mechanism-card">
        <h4>Lycopene</h4>
        <p>Provides antioxidant protection specifically for eye health,
          reducing the risk of age-related macular degeneration (AMD) and
          supporting overall retinal health.</p>
      </div>

      <div className="mechanism-card">
        <h4>Mixed Carotene</h4>
        <p>Contributes to eye health by neutralizing oxidative
          stress and protecting the macula from damage, potentially improving
          vision and slowing the progression of macular degeneration.</p>
      </div>
    </div>
  ]

  // mechanism of action ends

  // indications

  const [span, setSpan] = useState({
    neurological: "hidden",
    cardiovascular: "",
    oncological: "",
    gynaecological: "",
    general: "",
    ophthamology: ""
  })


  const [width, setWidth] = useState({
    neurological: "100%",
    cardiovascular: "",
    oncological: "",
    gynaecological: "",
    general: "",
    ophthamology: ""
  })
  const [display, setdisplay] = useState({
    neurological: "block",
    cardiovascular: "",
    oncological: "",
    gynaecological: "",
    general: "",
    ophthamology: ""
  })

  const openindication = (e) => {
    const id = e.currentTarget.id;
    // alert(id);

    if (id == "Neurological_Health") {
      setWidth({
        neurological: "100%",
        cardiovascular: "",
        oncological: "",
        gynaecological: "",
        general: "",
        ophthamology: ""
      });
      setdisplay({
        neurological: "block",
        cardiovascular: "",
        oncological: "",
        gynaecological: "",
        general: "",
        ophthamology: ""
      })
      setSpan({
        neurological: "hidden",
        cardiovascular: "",
        oncological: "",
        gynaecological: "",
        general: "",
        ophthamology: ""
      })
    } else if (id == "Cardiovascular_Health") {
      setWidth({
        neurological: "",
        cardiovascular: "100%",
        oncological: "",
        gynaecological: "",
        general: "",
        ophthamology: ""
      });
      setdisplay({
        neurological: "",
        cardiovascular: "block",
        oncological: "",
        gynaecological: "",
        general: "",
        ophthamology: ""
      })
      setSpan({
        neurological: "",
        cardiovascular: "hidden",
        oncological: "",
        gynaecological: "",
        general: "",
        ophthamology: ""
      })
    } else if (id == "Oncological_Health") {
      setWidth({
        neurological: "",
        cardiovascular: "",
        oncological: "100%",
        gynaecological: "",
        general: "",
        ophthamology: ""
      });
      setdisplay({
        neurological: "",
        cardiovascular: "",
        oncological: "block",
        gynaecological: "",
        general: "",
        ophthamology: ""
      })
      setSpan({
        neurological: "",
        cardiovascular: "",
        oncological: "hidden",
        gynaecological: "",
        general: "",
        ophthamology: ""
      })
    } else if (id == "Gynaecological_Health") {
      setWidth({
        neurological: "",
        cardiovascular: "",
        oncological: "",
        gynaecological: "100%",
        general: "",
        ophthamology: ""
      });
      setdisplay({
        neurological: "",
        cardiovascular: "",
        oncological: "",
        gynaecological: "block",
        general: "",
        ophthamology: ""
      })
      setSpan({
        neurological: "",
        cardiovascular: "",
        oncological: "",
        gynaecological: "hidden",
        general: "",
        ophthamology: ""
      })
    } else if (id == "General_surgeon") {
      setWidth({
        neurological: "",
        cardiovascular: "",
        oncological: "",
        gynaecological: "",
        general: "100%",
        ophthamology: ""
      });
      setdisplay({
        neurological: "",
        cardiovascular: "",
        oncological: "",
        gynaecological: "",
        general: "block",
        ophthamology: ""
      })
      setSpan({
        neurological: "",
        cardiovascular: "",
        oncological: "",
        gynaecological: "",
        general: "hidden",
        ophthamology: ""
      })
    }

    else if (id == "Opthamology") {
      setWidth({
        neurological: "",
        cardiovascular: "",
        oncological: "",
        gynaecological: "",
        general: "",
        ophthamology: "100%"
      });
      setdisplay({
        neurological: "",
        cardiovascular: "",
        oncological: "",
        gynaecological: "",
        general: "",
        ophthamology: "block"
      })
      setSpan({
        neurological: "",
        cardiovascular: "",
        oncological: "",
        gynaecological: "",
        general: "",
        ophthamology: "hidden"
      })
    }


  }

  // indications ends

  return (
    <div className='murinext'>
      <Header />

      <div className="product-images">
        {/* <img src={m1} alt="" /> */}
        <img src={m2} alt="" />
        <img src={m3} alt="" />
        {/* <img src={m4} alt="" /> */}
        <svg clip-rule="evenodd" fill-rule="evenodd" height="512" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Layer_x0020_1"><path d="m256 512c-69 0-133-27-181-75s-75-112-75-181c0-68 27-133 75-181s113-75 181-75 133 27 181 75 75 113 75 181c0 69-27 133-75 181s-112 75-181 75zm0-30c-60 0-117-24-160-66-42-43-66-100-66-160s24-117 66-160c43-42 100-66 160-66s117 24 160 66c42 43 66 100 66 160s-24 117-66 160c-43 42-100 66-160 66zm0-438c-117 0-212 95-212 212s95 212 212 212 212-95 212-212-95-212-212-212zm100 319-164-6c-2 0-4-1-5-2-2-2-2-4-2-5l2-40c0-4 3-7 7-7l72 2-115-115c-1-1-2-3-2-5s1-4 2-5l29-28c3-3 7-3 10 0l115 115-3-73c0-3 3-7 7-7l40-2c2 0 3 1 5 2 1 1 2 3 2 5l7 164c0 2-1 4-2 5s-3 2-5 2zm-157-20 150 6-7-150-26 2 4 84c0 3-2 5-4 6-3 2-6 1-8-1l-123-123-19 18 123 123c2 2 3 5 2 8-2 2-4 4-7 4l-83-3z" /></g></svg>
      </div>

      <section className="about">

        <h3 className="title">Product Description</h3>

        <div className="about-body">
          <h2>Murine XT</h2>
          <p className="tagline">Revitalize your health with precision
            formulation</p>
          <p>Murine-XT is a pharmaceutical therapeutic product designed to
            support overall health and vitality. Its active composition is designed to
            enhanced bioavailability, allowing for efficient absorption and utilization of
            essential nutrients. Research shows that Murine-XT not only provides
            assurance of active energy but also exhibits potent antioxidant properties,
            reducing oxidative stress and supporting cellular repair. With proven
            immunomodulatory effects, this medicinal product enhances immune
            function, making it suitable for individuals seeking to boost their health. this
            therapeutic product offers a balanced nutrient profile that promotes
            metabolic processes and overall wellness, ensuring a safe and well tolerated option for long-term health support.
          </p>

          <Link to="/buy-now">Buy Now</Link>
        </div>

      </section>

      <section className="mechanism">
        <h3 className="title">Mechanism Of Action</h3>

        <div className="mechanism-body">

          <div className="mechanism-option">
            <AliceCarousel
              mouseTracking
              items={items}
              responsive={responsive}
              controlsStrategy="alternate"
              autoPlay={true}
              infinite={true}
              autoPlayInterval={10000}
              disableDotsControls={true}
              renderPrevButton={() => {
                return <svg className='prev' id="Glyph" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m12 1.25c-5.9277 0-10.75 4.8223-10.75 10.75s4.8223 10.75 10.75 10.75 10.75-4.8223 10.75-10.75-4.8223-10.75-10.75-10.75zm-3.3721 15.0498c-.1445.1357-.3291.2031-.5127.2031-.2002 0-.3994-.0796-.5469-.2368-.2832-.3022-.2686-.7769.0342-1.0601l3.417-3.2061-3.417-3.2061c-.3027-.2832-.3174-.7578-.0342-1.0601.2832-.3018.7578-.3169 1.0596-.0337l3.6113 3.3882c.251.2354.3955.5674.3955.9116s-.1445.6763-.3955.9121l-3.6113 3.3877zm8.6113-3.3877-3.6113 3.3877c-.1445.1357-.3291.2031-.5127.2031-.2002 0-.3994-.0796-.5469-.2368-.2832-.3022-.2686-.7769.0342-1.0601l3.417-3.2061-3.417-3.2061c-.3027-.2832-.3174-.7578-.0342-1.0601.2832-.3018.7578-.3169 1.0596-.0337l3.6113 3.3882c.251.2354.3955.5674.3955.9116s-.1445.6763-.3955.9121z" /></svg>
              }}
              renderNextButton={() => {
                return <svg className='next' id="Glyph" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m12 1.25c-5.9277 0-10.75 4.8223-10.75 10.75s4.8223 10.75 10.75 10.75 10.75-4.8223 10.75-10.75-4.8223-10.75-10.75-10.75zm-3.3721 15.0498c-.1445.1357-.3291.2031-.5127.2031-.2002 0-.3994-.0796-.5469-.2368-.2832-.3022-.2686-.7769.0342-1.0601l3.417-3.2061-3.417-3.2061c-.3027-.2832-.3174-.7578-.0342-1.0601.2832-.3018.7578-.3169 1.0596-.0337l3.6113 3.3882c.251.2354.3955.5674.3955.9116s-.1445.6763-.3955.9121l-3.6113 3.3877zm8.6113-3.3877-3.6113 3.3877c-.1445.1357-.3291.2031-.5127.2031-.2002 0-.3994-.0796-.5469-.2368-.2832-.3022-.2686-.7769.0342-1.0601l3.417-3.2061-3.417-3.2061c-.3027-.2832-.3174-.7578-.0342-1.0601.2832-.3018.7578-.3169 1.0596-.0337l3.6113 3.3882c.251.2354.3955.5674.3955.9116s-.1445.6763-.3955.9121z" /></svg>
              }}
            />
          </div>


        </div>

        <div className="mechanism-body-mobile">
          <div className="mechanism-option">

            <div className="mechanism-button">
              <button className={activeClass1} onClick={showProduct}>Cardiovascular Health</button>
              <button className={activeClass2} onClick={showProduct}>Gynaecology</button>
              <button className={activeClass3} onClick={showProduct}>Oncology</button>
              <button className={activeClass4} onClick={showProduct}>General Surgery</button>
              <button className={activeClass5} onClick={showProduct}>Macular Degeneration (Ophthalmology)</button>
            </div>

            <div className="mechanism-right">
              {cardiovascular && (
                <div className="mechanism-option-body cardiovascular">
                  <div className="mechanism-card">
                    <h4>Ubiquinone (cardiovascular Q10)</h4>
                    <p>Enhances cellular energy production
                      and supports heart function by improving blood vessel health and
                      reducing oxidative stress. It helps in managing blood pressure and
                      improving overall cardiovascular performance.</p>
                  </div>

                  <div className="mechanism-card">
                    <h4>Lycopene</h4>
                    <p>Provides antioxidant protection to the cardiovascular
                      system, reducing the risk of heart disease by neutralizing harmful free
                      radicals and supporting healthy blood vessel function.
                    </p>
                  </div>


                  <div className="mechanism-card">
                    <h4>Omega-3 Fatty Acids (EPA & DHA)</h4>
                    <p>Essential for reducing
                      inflammation and supporting healthy cholesterol levels, omega-3s
                      contribute to heart health by lowering triglycerides and improving
                      arterial function.

                    </p>
                  </div>
                </div>
              )}

              {gynaecology && (
                <div className="mechanism-option-body gynaecology">
                  <div className="mechanism-card">
                    <h4>Wheat Germ Oil</h4>
                    <p> Rich in vitamin E and essential fatty acids, the oil
                      supports skin health and overall reproductive well-being and also
                      helps in hormonal balance and providing vital nutrients during
                      pregnancy.</p>
                  </div>

                  <div className="mechanism-card">
                    <h4>Vitamin B12</h4>
                    <p> Important for cellular function and energy production,
                      supporting overall reproductive health and managing symptoms
                      related to hormonal changes.
                    </p>
                  </div>
                  <div className="mechanism-card">
                    <h4>ubiquinone (cardiovascular Q10)</h4>
                    <p>Protects neuronal cells from oxidative
                      damage and supports mitochondrial function, potentially reducing
                      the risk of neurodegenerative diseases such as Parkinson’s and
                      Alzheimer’s.
                    </p>
                  </div>

                  <div className="mechanism-card">
                    <h4>Omega-3 Fatty Acids (EPA & DHA)</h4>
                    <p>Contribute to brain health by
                      supporting cognitive function, reducing inflammation, and protecting
                      against neurodegeneration.
                    </p>
                  </div>
                </div>
              )}

              {oncology && (
                <div className="mechanism-option-body">

                  <div className="mechanism-card">
                    <h4>Lycopene</h4>
                    <p>Known for its potential role in cancer prevention,
                      particularly prostate cancer, by reducing oxidative stress and
                      inhibiting cancer cell proliferation.
                    </p>
                  </div>

                  <div className="mechanism-card">
                    <h4>Selenium</h4>
                    <p>Acts as an antioxidant, potentially reducing the risk of
                      cancer and supporting the body’s natural defence mechanisms.
                    </p>
                  </div>
                </div>
              )}

              {surgery && (
                <div className="mechanism-option-body">

                  <div className="mechanism-card">
                    <h4>Calcium Ascorbate</h4>
                    <p>Supports wound healing and recovery by
                      enhancing collagen synthesis and immune function, crucial for postsurgical repair and overall recovery.</p>
                  </div>

                  <div className="mechanism-card">
                    <h4>Zinc</h4>
                    <p>Essential for cellular repair and immune function, helping in
                      faster recovery and reducing the risk of post-surgical complications.</p>
                  </div>
                </div>
              )}

              {ophthalmology && (
                <div className="mechanism-option-body">

                  <div className="mechanism-card">
                    <h4>Lycopene</h4>
                    <p>Provides antioxidant protection specifically for eye health,
                      reducing the risk of age-related macular degeneration (AMD) and
                      supporting overall retinal health.</p>
                  </div>

                  <div className="mechanism-card">
                    <h4>Mixed Carotene</h4>
                    <p>Contributes to eye health by neutralizing oxidative
                      stress and protecting the macula from damage, potentially improving
                      vision and slowing the progression of macular degeneration.</p>
                  </div>
                </div>
              )}
            </div>


          </div>
        </div>
      </section>

      <section className="salt">
        <h3 className="title">
          Salt Composition
        </h3>
        <div className="salt-body">
          <p>ubiquinone (Coenzyme Q10) -100 mg</p>
          <p>Lycopene -5000 mcg</p>
          <p>Omega-3 Fatty Acids: EPA- 90 mg, DHA -60 mg</p>
          <p>Mixed Carotene 10% -10.33 mg</p>
          <p>Wheat Germ Oil -25 mg</p>
          <p>Calcium Ascorbate -75 mcg</p>
          <p>Piperine -5 mg</p>
          <p>Vitamin B12- 5 mcg</p>
          <p>Selenium Dioxide Monohydrate -75 mcg</p>
          <p>Zinc Sulphate Monohydrate- 27.45 mg</p>
        </div>
      </section>

      <section className="dosage">
        <h3 className="title">Dosage & Instructions</h3>
        <div className="dosage-body">
          <div className="dosage-card">
            <div className="img">
              <img src={d1} alt="" />
            </div>
            <div className="dosage-card-text">
              <h4>Dosage</h4>
              <p>As Directed by Physician</p>
            </div>
          </div>

          <div className="dosage-card">
            <div className="img">
              <img src={d2} alt="" />
            </div>
            <div className="dosage-card-text">
              <h4>Administration Instructions</h4>
              <p>Do not chew or crush the capsule. For best results, swallow the
                capsule whole with a glass of water.</p>
            </div>
          </div>

          <div className="dosage-card">
            <div className="img">
              <img src={d3} alt="" />
            </div>
            <div className="dosage-card-text">
              <h4>Storage</h4>
              <p>store in a cool, dry place away from direct sunlight and moisture.</p>
            </div>
          </div>

          <div className="dosage-card">
            <div className="img">
              <img src={d4} alt="" />
            </div>
            <div className="dosage-card-text">
              <h4>General Instructions:</h4>
              <p>Keep the medicines out of reach of children.</p>
              <p>Store Murine-XT in a safe place away from children to prevent
                accidental ingestion.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="indications">
        <h3 className="title">Indications</h3>

        <div className="indications-body">
          <div className="indications-card" id='Neurological_Health' onClick={openindication} style={{ width: width.neurological }}>
            <span style={{ visibility: span.neurological }}> Neurological Health</span>
            <img src={i3} alt="" />
            <div className="indications-card-text" style={{ display: display.neurological }}>
              <h3>Neurological Health</h3>
              {/* <p>Supports heart health and recovery</p> */}
              <ul>
                <li>Migraine: Supports relief from migraine symptoms through its
                  antioxidant and anti-inflammatory properties.</li>
                <li>Headache: Helps in managing and reducing the frequency of
                  headaches.</li>
                <li>Parkinson’s Disease: helps in neuronal protection and support
                  overall brain function.
                </li>
                <li>Alzheimer’s Disease: Contributes to cognitive health and will help to
                  slow cognitive decline.</li>
                <li>Stroke: Supports recovery and neurological function post-stroke
                  through its antioxidant and anti-inflammatory effects.</li>
              </ul>
            </div>
          </div>

          <div className="indications-card" id='Cardiovascular_Health' onClick={openindication} style={{ width: width.cardiovascular }}>
            <span style={{ visibility: span.cardiovascular }}>Cardiovascular Health</span>
            <img src={i1} alt="" />
            <div className="indications-card-text" style={{ display: display.cardiovascular }}>
              <h3>Cardiovascular Health</h3>
              {/* <p>Supports cancer treatment and overall health.</p> */}
              <ul>
                <li>Heart Failure: Supports cardiovascular function and overall heart
                  health.</li>
                <li>Atherosclerosis: also help in managing arterial health and reducing
                  oxidative stress.</li>
                <li>Cardiotoxicity: Provides protection against damage to the heart
                  caused by certain medications or conditions.</li>
                <li>Hypertension: Assists in maintaining healthy blood pressure levels.</li>
                <li>Arrhythmia: Supports heart rhythm regulation and overall cardiac
                  function.</li>
                <li>Angina Pectoris: helps in reducing symptoms associated with angina
                  and supporting heart health.</li>
              </ul>
            </div>
          </div>

          <div className="indications-card" id='Oncological_Health' onClick={openindication} style={{ width: width.oncological }}>
            <span style={{ visibility: span.oncological }}>Oncology</span>
            <img src={i2} alt="" />
            <div className="indications-card-text" style={{ display: display.oncological }}>
              <h3>Oncology</h3>
              {/* <p>Supports brain function and protects against
                neurodegenerative diseases</p> */}
              <ul>
                <li>Prostate Cancer: murine-XT contribute to cancer prevention and
                  support overall prostate health</li>
                <li>Colorectal Cancer: Provides antioxidant support and helps in
                  reducing oxidative stress associated with colorectal cancer.</li>
                <li>Brain Cancer: Supports overall brain health and also helps in
                  managing symptoms related to brain cancer.</li>
              </ul>
            </div>
          </div>

          <div className="indications-card" id='Gynaecological_Health' onClick={openindication} style={{ width: width.gynaecological }}>
            <span style={{ visibility: span.gynaecological }}>Gynaecology</span>
            <img src={i4} alt="" />
            <div className="indications-card-text" style={{ display: display.gynaecological }}>
              <h3>Gynaecology</h3>
              {/* <p>Supports ovarian function and manages gynaecological
                conditions.</p> */}
              <ul>
                <li>Infertility: Supports reproductive health and overall hormonal
                  balance.</li>
                <li>Other Gynaecological Conditions: Provides support for various
                  gynaecological conditions, enhancing overall well-being.
                </li>
              </ul>
            </div>
          </div>

          <div className="indications-card" id='General_surgeon' onClick={openindication} style={{ width: width.general }}>
            <span style={{ visibility: span.general }}>General surgeon</span>
            <img src={i5} alt="" />
            <div className="indications-card-text" style={{ display: display.general }}>
              <h3>General surgeon</h3>
              <p></p>
              <ul>
                <li>Convalescence: helps in recovery and healing after illness or
                  surgery, supporting overall vitality and well-being.
                </li>
              </ul>
            </div>
          </div>

          <div className="indications-card" id='Opthamology' onClick={openindication} style={{ width: width.ophthamology }}>
            <span style={{ visibility: span.ophthamology }}> Ophthalmology</span>
            <img src={i6} alt="" />
            <div className="indications-card-text" style={{ display: display.ophthamology }}>
              <h3>Ophthalmology</h3>
              <p></p>
              <ul>
                <li>Macular Degeneration: Supports eye health and also help in
                  managing age-related macular degeneration through its antioxidant
                  properties.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="safety">
        <h3 className="title">Safety Information</h3>

        <div className="safety-body">
          <div className="safety-card">
            <svg id="Layer_1" enable-background="new 0 0 64 64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><g><path d="m47.6 10.13c0 .28-.23.49-.49.49-.28 0-.5-.22-.5-.49s.22-.49.49-.49h.01c.27 0 .49.22.49.49z" fill="#4e5292" /><path d="m45.12 21.01c0 .27-.23.49-.49.49-.28 0-.5-.23-.5-.49 0-.28.22-.49.49-.49h.01c.26 0 .49.22.49.49z" fill="#4e5292" /><path d="m55.99 23.48c0 .28-.22.49-.49.49-.28 0-.5-.22-.5-.49s.22-.49.49-.49h.01c.27 0 .49.23.49.49z" fill="#4e5292" /><path d="m59.31 17.08c-.65-.14-1.29.16-1.62.69l-1.66-.38c.12-.93-.04-1.84-.45-2.68l.99-.63c.27.25.58.43.95.51.15.04.31.06.45.06.38 0 .75-.11 1.08-.31.45-.29.78-.74.9-1.27.12-.52.03-1.07-.27-1.53-.29-.46-.73-.78-1.26-.9-.53-.13-1.07-.03-1.54.26-.45.29-.78.74-.9 1.27-.08.36-.06.73.06 1.07l-.99.63c-.58-.74-1.34-1.28-2.23-1.58l.38-1.68c.62-.07 1.16-.5 1.31-1.15.09-.39.02-.8-.19-1.14-.22-.34-.55-.58-.96-.67-.82-.19-1.62.32-1.81 1.14-.09.39-.02.8.2 1.14.12.2.3.34.48.46l-.38 1.68c-.95-.12-1.87.05-2.68.45l-.63-.99c.26-.27.43-.59.52-.96.12-.52.03-1.07-.27-1.53-.29-.46-.74-.78-1.26-.9-.53-.13-1.07-.03-1.54.26-.45.29-.78.74-.9 1.27-.12.52-.03 1.06.26 1.53.3.46.74.78 1.27.9.15.04.31.06.45.06.22 0 .42-.05.62-.11l.63.99c-.72.56-1.27 1.32-1.58 2.23l-1.64-.37c-.03-.23-.1-.44-.22-.65-.22-.34-.55-.58-.96-.67-.81-.19-1.62.32-1.81 1.14-.09.39-.02.8.2 1.14s.55.58.95.68c.11.02.23.03.33.03.52 0 1.01-.28 1.29-.71l1.66.37c-.12.93.04 1.85.45 2.69l-.99.62c-.27-.26-.58-.43-.95-.51-.53-.13-1.07-.03-1.54.26-.45.29-.78.74-.9 1.27-.12.52-.03 1.07.26 1.53.3.46.74.78 1.27.9.15.04.31.06.45.06.38 0 .75-.11 1.07-.31.46-.29.79-.74.91-1.27.08-.36.06-.73-.06-1.07l.99-.63c.58.74 1.34 1.28 2.23 1.58l-.37 1.65c-.23.02-.44.09-.64.22-.34.22-.58.55-.67.95-.19.82.32 1.62 1.13 1.81.12.03.23.04.34.04.69 0 1.32-.47 1.48-1.18.09-.39.02-.8-.2-1.14-.12-.2-.3-.34-.48-.46l.37-1.65c.2.02.38.03.58.03.75 0 1.46-.19 2.11-.5l.62.99c-.25.26-.43.58-.51.95-.12.52-.03 1.07.27 1.53.29.46.73.78 1.26.9.15.04.31.06.45.06.38 0 .75-.11 1.08-.31.45-.29.78-.74.9-1.27.12-.52.03-1.06-.27-1.53-.29-.46-.74-.78-1.26-.9-.36-.09-.74-.06-1.08.05l-.62-.97c.72-.56 1.27-1.33 1.58-2.24l1.66.38c.07.62.52 1.16 1.16 1.31.12.03.23.04.34.04.69 0 1.31-.48 1.48-1.18.2-.84-.31-1.66-1.13-1.85zm-2.37-4.69c.07-.28.24-.5.46-.65.24-.15.52-.2.8-.14.27.06.5.23.65.46.15.24.2.51.13.79-.06.28-.23.5-.46.65s-.51.2-.79.14c-.27-.06-.48-.23-.63-.45-.01 0-.01-.01-.01-.01 0-.01-.01-.01-.01-.02-.15-.23-.2-.51-.14-.77zm-8.84-2.02c-.06.27-.22.49-.44.64-.01 0-.02 0-.02.01-.01 0-.01.01-.01.01-.24.14-.51.19-.78.13s-.5-.23-.65-.46c-.15-.24-.2-.52-.14-.79.07-.28.23-.5.46-.65.18-.11.36-.17.56-.17.08 0 .16.01.23.03.28.06.51.23.66.46.15.24.2.51.13.79zm-3.98 4.8c-.06.26-.29.42-.52.42-.04 0-.08-.01-.12-.02-.14-.03-.26-.12-.33-.24s-.1-.27-.07-.4c.06-.25.28-.41.52-.41.04 0 .08.01.12.02.14.03.26.11.33.24.08.12.1.25.07.39zm1.5 6.07c-.06.28-.23.5-.46.65-.24.15-.51.2-.79.14-.27-.06-.5-.23-.65-.46-.15-.24-.2-.51-.14-.79.07-.28.23-.5.46-.65.18-.11.36-.17.56-.17.08 0 .16.01.23.03.28.06.5.23.65.45v.01s.01 0 .01.01c.15.23.19.51.13.78zm8.85 2.02c.06-.28.23-.5.46-.65s.51-.2.79-.14c.27.06.5.23.65.46.15.24.2.51.13.79-.06.28-.23.5-.46.65s-.51.2-.79.14c-.27-.06-.5-.23-.65-.46-.15-.24-.2-.52-.13-.79zm-1.95-14.25c.06-.25.28-.41.52-.41.04 0 .08 0 .12.01.14.03.26.12.33.24.08.12.1.27.07.4-.07.29-.35.46-.64.39-.14-.03-.26-.11-.33-.23-.07-.13-.1-.26-.07-.4zm-2.48 15.6c-.06.29-.35.47-.63.4-.29-.07-.47-.35-.4-.64.03-.14.12-.26.24-.34.09-.05.18-.08.29-.08.03 0 .07.01.1.01.01 0 .01.01.02.01h.01c.14.04.25.12.31.23.07.14.1.28.06.41zm4.96-6.95c-.23.98-.83 1.83-1.68 2.37-.87.54-1.88.72-2.88.49-.99-.23-1.84-.83-2.38-1.69s-.71-1.88-.48-2.88c.4-1.76 1.98-2.95 3.71-2.95.28 0 .55.03.84.09l.01.01h.02c.98.23 1.82.83 2.36 1.68.38.61.58 1.3.58 2.01 0 .29-.03.59-.1.87zm4.49 1.03c-.06.29-.35.46-.63.39-.25-.05-.41-.28-.41-.52 0-.03 0-.07.01-.11.06-.25.28-.41.52-.41.04 0 .08 0 .12.01.28.07.46.35.39.64z" fill="#4e5292" /><path d="m58.47 12.61c0 .28-.23.49-.49.49-.28 0-.5-.22-.5-.49s.22-.49.49-.49h.01c.27 0 .49.23.49.49z" fill="#4e5292" /><path d="m54.11 4.42c-3.31-.76-6.72-.18-9.59 1.62-2.88 1.81-4.87 4.63-5.63 7.94-.92 4.02.17 8.22 2.91 11.29l-.87 3.68c-.04.17.02.35.16.47.09.09.21.13.32.13.06 0 .11-.01.17-.03l3.87-1.43c.96.5 1.98.88 3 1.1 3.3.76 6.72.18 9.59-1.62 2.88-1.81 4.87-4.63 5.63-7.94 1.57-6.82-2.73-13.65-9.56-15.21zm8.61 15.01c-.7 3.05-2.54 5.65-5.19 7.32-2.66 1.66-5.8 2.21-8.85 1.51-1-.23-2-.61-2.95-1.12-.07-.04-.15-.06-.24-.06-.06 0-.11.01-.17.03l-3.21 1.19.71-3.04c.04-.16-.01-.33-.12-.44-2.65-2.86-3.71-6.81-2.85-10.6.69-3.05 2.54-5.65 5.19-7.32 2.65-1.66 5.8-2.21 8.85-1.51 6.31 1.42 10.26 7.72 8.83 14.04z" fill="#4e5292" /><path d="m53.89 5.37c-3.05-.7-6.2-.16-8.85 1.51-2.65 1.66-4.5 4.26-5.19 7.32-.87 3.79.2 7.75 2.85 10.6.11.12.16.29.12.44l-.71 3.04 3.21-1.19c.06-.02.11-.03.17-.03.09 0 .17.02.24.06.96.51 1.95.9 2.95 1.12 3.05.7 6.19.16 8.85-1.51 2.65-1.66 4.49-4.26 5.19-7.32 1.43-6.3-2.52-12.6-8.83-14.04zm6.56 13.53c-.17.7-.79 1.18-1.48 1.18-.12 0-.23-.01-.34-.04-.64-.15-1.09-.69-1.16-1.31l-1.66-.38c-.31.91-.86 1.67-1.58 2.24l.62.97c.34-.11.72-.14 1.08-.05.52.12.97.43 1.26.9.3.46.38 1 .27 1.53-.12.53-.44.98-.9 1.27-.33.21-.7.31-1.08.31-.15 0-.31-.02-.45-.06-.53-.12-.97-.43-1.26-.9-.3-.45-.38-1-.27-1.53.08-.36.27-.69.51-.95l-.62-.99c-.65.31-1.36.5-2.11.5-.2 0-.38-.01-.58-.03l-.37 1.65c.19.12.36.27.48.46.22.34.29.75.2 1.14-.16.71-.79 1.18-1.48 1.18-.12 0-.23-.01-.34-.04-.81-.19-1.32-.99-1.13-1.81.09-.39.32-.73.67-.95.2-.13.41-.2.64-.22l.38-1.67c-.89-.3-1.64-.84-2.23-1.58l-.99.63c.12.34.14.71.06 1.07-.12.53-.44.98-.91 1.27-.32.21-.69.31-1.07.31-.15 0-.31-.02-.45-.06-.53-.12-.97-.43-1.27-.9-.29-.45-.37-1-.26-1.53.12-.53.44-.98.9-1.27s1-.38 1.54-.26c.36.08.68.26.95.51l.98-.57c-.41-.84-.57-1.76-.45-2.69l-1.66-.37c-.28.43-.77.71-1.29.71-.11 0-.23-.01-.33-.03-.39-.1-.73-.34-.95-.68s-.29-.75-.2-1.14c.19-.82 1-1.33 1.81-1.14.4.09.74.32.96.67.12.21.19.42.22.65l1.66.38c.31-.91.86-1.66 1.58-2.23l-.63-.99c-.2.06-.4.11-.62.11-.15 0-.31-.02-.45-.06-.53-.12-.97-.43-1.27-.9-.29-.46-.37-1-.26-1.53.12-.53.44-.98.9-1.27s1-.38 1.54-.26c.52.12.97.43 1.26.9.3.45.38 1 .27 1.53-.09.36-.27.69-.52.96l.63.99c.81-.4 1.73-.57 2.68-.45l.38-1.68c-.19-.12-.36-.27-.48-.46-.22-.34-.29-.75-.2-1.14.19-.82.99-1.33 1.81-1.14.4.09.74.32.96.67.21.34.28.75.19 1.14-.15.65-.69 1.08-1.31 1.15l-.38 1.68c.89.3 1.64.84 2.23 1.58l.99-.63c-.12-.34-.14-.71-.06-1.07.12-.53.44-.98.9-1.27s1-.38 1.54-.26c.53.12.97.43 1.26.9.3.45.38 1 .27 1.53-.12.53-.44.98-.9 1.27-.33.21-.7.31-1.08.31-.15 0-.31-.02-.45-.06-.36-.08-.68-.27-.95-.51l-.99.63c.41.84.57 1.75.45 2.68l1.66.38c.33-.53.97-.83 1.62-.69.79.18 1.3 1 1.11 1.81z" fill="#ffdb7c" /><path d="m60.74 23.73c-.2.29-.41.56-.65.83-.47.43-.98.82-1.54 1.16-2.66 1.66-5.8 2.21-8.85 1.51-1-.23-2-.61-2.95-1.12-.07-.04-.15-.06-.24-.06-.06 0-.11.01-.17.03l-3.21 1.19.71-3.04c.04-.16-.01-.32-.12-.44-2.65-2.86-3.71-6.81-2.85-10.6.43-1.93 1.34-3.68 2.63-5.13.26-.24.53-.46.82-.66-.94 1.26-1.6 2.71-1.95 4.28-.25 1.06-.33 2.15-.29 3.21 0 0 .01 0 0 .01-.02.2 0 .39.05.58v.01c.15 1.39.53 2.74 1.15 3.99-.33.29-.56.66-.66 1.09-.12.52-.03 1.07.26 1.53.3.46.74.78 1.27.9.15.04.31.06.45.06.24 0 .46-.04.68-.13l-.66 2.85 3.21-1.19c.06-.02.11-.03.17-.03h.01c.02.68.48 1.28 1.17 1.44.12.03.23.04.34.04.41 0 .8-.17 1.08-.45.19.06.38.12.58.16 3.05.7 6.19.16 8.85-1.51.25-.18.49-.33.71-.51z" fill="#f0ca6c" /><path d="m60.09 24.56c-.73.84-1.6 1.58-2.56 2.19-2.66 1.66-5.8 2.21-8.85 1.51-1-.23-2-.61-2.95-1.12-.07-.04-.15-.06-.24-.06-.06 0-.11.01-.17.03l-3.21 1.19.71-3.04c.04-.16-.01-.33-.12-.44-2.65-2.86-3.71-6.81-2.85-10.6.54-2.42 1.82-4.56 3.65-6.15-1.29 1.45-2.2 3.2-2.63 5.13-.87 3.79.2 7.75 2.85 10.6.11.12.16.29.12.44l-.71 3.04 3.21-1.19c.06-.02.11-.03.17-.03.09 0 .17.02.24.06.96.51 1.95.9 2.95 1.12 3.05.7 6.19.16 8.85-1.51.55-.36 1.06-.74 1.54-1.17z" fill="#e1ba62" /><g fill="#a5d179"><path d="m50.04 24.61c-.06.29-.35.47-.63.4-.29-.07-.47-.35-.4-.64.03-.14.12-.26.24-.34.09-.05.18-.08.29-.08.03 0 .07.01.1.01.01 0 .01.01.02.01h.01c.14.04.25.12.31.23.07.14.1.28.06.41z" /><path d="m56.37 22.93c-.15-.24-.38-.4-.65-.46-.28-.06-.56-.01-.79.14-.24.15-.4.37-.46.65-.07.28-.02.55.13.79s.38.4.65.46c.28.06.55.01.79-.14s.4-.37.46-.65.01-.55-.13-.79zm-.87 1.05c-.28 0-.5-.22-.5-.49s.22-.49.49-.49h.01c.28 0 .49.23.49.49 0 .27-.22.49-.49.49z" /><path d="m59.49 18.69c-.06.29-.35.46-.63.39-.25-.05-.41-.28-.41-.52 0-.03 0-.07.01-.11.06-.25.28-.41.52-.41.04 0 .08 0 .12.01.28.07.46.35.39.64z" /><path d="m45.5 20.46c0-.01-.01-.01 0 0l-.01-.02c-.15-.23-.37-.39-.65-.45-.07-.02-.15-.03-.23-.03-.2 0-.38.06-.56.17-.24.15-.39.37-.46.65-.06.28-.01.55.14.79s.38.4.65.46c.28.06.55.01.79-.14s.4-.37.46-.65c.05-.27.01-.55-.13-.78zm-.87 1.04c-.28 0-.5-.23-.5-.49 0-.28.22-.49.49-.49h.01c.27 0 .49.22.49.49s-.23.49-.49.49z" /><path d="m44.12 15.17c-.06.26-.29.42-.52.42-.04 0-.08-.01-.12-.02-.14-.03-.26-.12-.33-.24s-.1-.27-.07-.4c.06-.25.28-.41.52-.41.04 0 .08.01.12.02.14.03.26.11.33.24.08.12.1.25.07.39z" /><path d="m47.98 9.58c-.15-.24-.38-.4-.66-.46-.07-.02-.15-.03-.23-.03-.2 0-.38.06-.56.17-.24.15-.39.37-.46.65-.06.27-.01.55.14.79s.38.4.65.46.54.01.78-.13c0 0 0-.01.01-.01 0-.01.01-.01.02-.01.23-.15.38-.37.44-.64.06-.28.01-.55-.13-.79zm-.87 1.04c-.28 0-.5-.22-.5-.49s.22-.49.49-.49h.01c.27 0 .49.23.49.49 0 .28-.22.49-.49.49z" /><path d="m53.56 9.24c-.07.29-.35.46-.64.39-.14-.03-.26-.11-.33-.23-.07-.13-.1-.27-.07-.4.06-.25.28-.41.52-.41.04 0 .08 0 .12.01.14.03.26.12.33.24.08.12.1.27.07.4z" /><path d="m58.85 12.06c-.15-.24-.38-.4-.65-.46-.28-.06-.56-.01-.8.14-.23.15-.39.37-.46.65-.06.27-.01.54.14.77 0 .01.01.01.01.02 0 0 0 .01.01.01.15.23.36.39.63.45.28.06.55.01.79-.14s.4-.37.46-.65.01-.55-.13-.79zm-.87 1.04c-.28 0-.5-.22-.5-.49s.22-.49.49-.49h.01c.27 0 .49.23.49.49 0 .28-.22.49-.49.49z" /></g><path d="m55.1 16.8c0 .29-.03.58-.1.87-.23.98-.83 1.83-1.68 2.37-.87.54-1.88.72-2.88.49-.99-.23-1.84-.83-2.38-1.69s-.71-1.88-.48-2.88c.4-1.76 1.98-2.95 3.71-2.95.28 0 .55.03.84.09l.01.01h.02c.98.23 1.82.83 2.36 1.68.38.61.58 1.3.58 2.01z" fill="#bfdda0" /><path d="m54.28 19.16c-.27.34-.59.64-.97.88-.87.54-1.88.72-2.88.49-.99-.23-1.84-.83-2.38-1.69s-.71-1.88-.48-2.88c.21-.89.69-1.6 1.35-2.13-.33.42-.57.92-.69 1.47-.23.99-.06 2.02.48 2.88.54.87 1.39 1.47 2.38 1.69.99.23 2.01.05 2.88-.49.11-.07.21-.14.31-.22z" fill="#94c36b" /><path d="m54.75 18.37c-.12.29-.29.55-.47.79-.1.08-.2.15-.31.22-.87.54-1.88.72-2.88.49-.99-.23-1.84-.83-2.38-1.69s-.71-1.88-.48-2.88c.12-.55.36-1.04.69-1.47l.01-.01c.25-.2.52-.36.81-.49-.11.23-.19.46-.25.71-.23.99-.06 2.02.48 2.88.54.87 1.39 1.47 2.38 1.69.83.19 1.65.1 2.4-.24z" fill="#a5d179" /><path d="m36.12 38.99c-.55-4.85-.87-11.89-1-22.12-.03-3.7-1.52-7.18-4.17-9.79-2.63-2.61-6.11-4.05-9.83-4.05-7.58 0-13.86 6.17-14 13.76-.2 10.33-.51 17.2-1.03 22.2-3.46.69-6.09 3.74-6.09 7.4v3.49.01c-.01.03 0 .05 0 .07v10.52c0 .28.23.49.49.49h8.88.01.02 23.51.02.01 8.89c.28 0 .49-.22.49-.49v-14.09c.01-3.71-2.67-6.78-6.2-7.4zm-28.01-22.16c.13-7.06 5.97-12.8 13.02-12.8 3.45 0 6.7 1.34 9.14 3.76 2.46 2.42 3.84 5.65 3.87 9.1.14 10.1.45 17.11.98 22-.11-.01-.21-.02-.32-.02h-4.13c-1.01 0-1.91-.2-2.68-.61-.03-.02-.07-.04-.1-.06-.38-1.27-.73-2.67-.94-4.06 1.96-1.93 3.37-4.69 3.98-7.65 1.2-.38 2.24-2.21 2.35-3.73.1-1.43-.19-2.36-.84-2.8-.42-.29-.96-.33-1.57-.14-.09-.33-.19-.66-.3-.97-.06-.17-.2-.3-.37-.33-10.09-1.74-11.2-5.2-11.21-5.22-.05-.21-.23-.36-.44-.37-.21-.02-.4.1-.49.3-1.46 3.53-6.03 5.05-6.08 5.07-.14.05-.26.16-.31.3-.15.4-.27.82-.36 1.24-.61-.2-1.15-.16-1.58.13-.66.43-.95 1.37-.84 2.8.11 1.54 1.14 3.36 2.36 3.73.58 2.82 1.88 5.46 3.68 7.37-.16 1.63-.37 3.1-.59 4.36-.03.02-.04.04-.08.05-.74.4-1.61.6-2.63.6h-4.1c-.15 0-.29.02-.43.02.5-5.02.81-11.87 1.01-22.07zm16.34 27.01-7.03.44.01-.39c.27-1.91 1.14-7.07 2.01-8.43.15-.23.08-.53-.15-.68s-.53-.08-.68.15c-1 1.57-1.85 6.75-2.1 8.38l-2.19-.29c.37-1.32 1.26-4.84 1.69-9.83.45-5.34 4.57-5.73 5.25-5.76.58.24 4.2 1.89 4.61 5.94.18 1.8.62 3.63 1.1 5.24.01.01.01.02.01.03.58 1.9 1.21 3.48 1.55 4.25l-3.09.87c-.25-.94-.88-3.69-1.29-8.61-.02-.27-.3-.47-.53-.44-.28.02-.47.26-.45.53.41 4.73 1 7.47 1.28 8.6zm-3.94-19.86c.34.62.81 1.68.97 2.49-.04-.01-.08-.03-.12-.03-.23 0-5.41.1-6.24 6.09-1.99-2.46-3.2-5.94-3.2-9.35 0-1.42.21-2.78.63-4.03 1.63-.59 4.54-2.18 6.02-4.69.95 1.3 3.67 3.62 11.2 4.98.11.34.2.71.28 1.08 0 .01.01.02.01.03.17.83.26 1.7.26 2.62 0 3.62-1.33 7.24-3.51 9.7-.5-3.37-2.89-5.17-4.28-5.94-.02-1.34-1-3.21-1.13-3.44-.13-.24-.42-.33-.67-.2-.25.14-.34.45-.22.69zm10.58-3.19c.35-.13.65-.14.83-.02.32.22.46.91.39 1.91-.08 1-.62 2.04-1.17 2.55.09-.68.15-1.37.15-2.06 0-.82-.07-1.62-.2-2.38zm-20.01 4.46c-.55-.51-1.1-1.55-1.17-2.56-.08-1 .07-1.69.39-1.91.18-.12.47-.11.83.02-.14.77-.2 1.57-.2 2.38 0 .69.06 1.38.15 2.07zm-10.09 34.72v-9.46l5.84.75c-.97 4.51.37 6.56 1.36 8.07.15.23.29.43.4.64zm8.7 0c-.19-.39-.42-.78-.68-1.17-.98-1.51-2.21-3.38-1.1-7.85.03-.14 0-.28-.08-.39-.08-.12-.2-.2-.33-.21l-6.51-.84v-3.13c0-3.6 2.93-6.54 6.54-6.54h4.15c.92 0 1.75-.15 2.49-.44-.48 2.43-.94 3.86-.95 3.88-.04.14-.02.3.06.41.07.13.21.21.34.23l2.82.36v.51c0 .14.05.27.15.36s.22.14.34.14h.03l4.75-.29c.32 2.59.83 5.39 1.48 8.13.45 1.87.76 4.24.89 6.84zm15.37 0c-.1-1.98-.34-4.67-.93-7.07-.64-2.69-1.13-5.44-1.45-7.98l2.81-.18c.04 0 .07-.01.1-.02l1.92-.53.03.09c.47 1.9 1.26 5.06 2.37 8.5.43 1.34.86 2.54 1.23 3.61.5 1.44.91 2.62 1.16 3.57h-7.24zm16.29 0h-7.61c.12-.21.26-.41.4-.64.98-1.52 2.33-3.56 1.36-8.07l5.85-.75zm0-10.45-6.52.84c-.14.01-.26.09-.34.21s-.1.26-.07.39c1.1 4.47-.12 6.34-1.1 7.85-.08.11-.15.23-.22.33-.26-.87-.61-1.88-1.02-3.06-.36-1.06-.79-2.25-1.22-3.59-1.1-3.4-1.89-6.55-2.35-8.43l-.03-.12.89-.25c.14-.04.26-.14.32-.27s.06-.29 0-.41c-.01-.03-.68-1.5-1.38-3.55.72.27 1.52.39 2.38.39h4.13c3.61 0 6.55 2.93 6.55 6.54v3.13z" fill="#4e5292" /><path d="m34.49 50.56c-.08.12-.1.26-.07.39 1.1 4.47-.12 6.34-1.1 7.85-.08.11-.15.23-.22.33-.26-.87-.61-1.88-1.02-3.06-.36-1.06-.79-2.25-1.22-3.59-1.1-3.4-1.89-6.55-2.35-8.43l-.03-.12.89-.25c.14-.04.26-.14.32-.27s.06-.29 0-.41c-.01-.03-.68-1.5-1.38-3.55.72.27 1.52.39 2.38.39h4.13c3.61 0 6.55 2.93 6.55 6.54v3.13l-6.52.84c-.16.01-.27.09-.36.21z" fill="#98d3ba" /><path d="m8.59 59.97h-7.6v-9.46l5.84.75c-.97 4.51.37 6.56 1.36 8.07.14.23.28.44.4.64z" fill="#f0d299" /><path d="m24.07 59.97h-14.38c-.19-.39-.42-.78-.68-1.17-.98-1.51-2.21-3.38-1.1-7.85.03-.14 0-.28-.08-.39-.08-.12-.2-.2-.33-.21l-6.51-.84v-3.13c0-3.6 2.93-6.54 6.54-6.54h4.15c.92 0 1.75-.15 2.49-.44-.48 2.43-.94 3.86-.95 3.88-.04.14-.02.3.06.41.07.13.21.21.34.23l2.82.36v.51c0 .14.05.27.15.36s.22.14.34.14h.03l4.75-.29c.32 2.59.83 5.39 1.48 8.13.45 1.87.75 4.24.88 6.84z" fill="#98d3ba" /><path d="m41.35 50.51v9.46h-7.61c.12-.21.26-.41.4-.64.98-1.52 2.33-3.56 1.36-8.07z" fill="#f0d299" /><path d="m2.8 50.75v9.22h-1.81v-9.46z" fill="#dfc189" /><path d="m14.16 39.4c-.11.55-.22 1.04-.32 1.49-.12.02-.25.02-.36.02h-4.14c-3.6 0-6.54 2.78-6.54 6.19v2.65l-1.81-.24v-3.13c0-3.6 2.93-6.54 6.54-6.54h4.15c.91.01 1.75-.14 2.48-.44z" fill="#89c3a8" /><g><path d="m39.54 50.75v9.22h1.81v-9.46z" fill="#ffe4aa" /><path d="m41.35 46.39v3.13l-1.81.24v-2.66c0-3.42-2.93-6.19-6.54-6.19h-4.19c-.16-.43-.33-.93-.51-1.46.12.04.24.09.36.12.04.01.07.02.11.04.13.03.27.06.4.09.27.06.54.1.83.12.21.02.42.03.65.03h.02 4.15c3.6 0 6.53 2.93 6.53 6.54z" fill="#b9e0ce" /></g><path d="m32.31 59.97h-7.25c-.1-1.98-.34-4.67-.93-7.07-.64-2.69-1.13-5.44-1.45-7.98l2.81-.18c.04 0 .07-.01.1-.02l1.92-.53.03.09c.47 1.9 1.26 5.06 2.37 8.5.43 1.34.86 2.54 1.23 3.61.51 1.45.91 2.63 1.17 3.58z" fill="#f0d299" /><path d="m25.73 59.97h-.67c-.1-1.98-.34-4.67-.93-7.07-.64-2.69-1.13-5.44-1.45-7.98l.68-.04c.31 2.52.81 5.36 1.44 8.01.59 2.42.83 5.1.93 7.08z" fill="#dfc189" /><path d="m32.31 59.97h-.68c-.26-.96-.66-2.14-1.16-3.57-.37-1.07-.8-2.27-1.23-3.61-1.1-3.38-1.88-6.51-2.35-8.41l.63-.18.03.09c.01.03.01.05.02.08.47 1.9 1.25 5.03 2.35 8.42.43 1.34.86 2.54 1.23 3.61.5 1.44.9 2.62 1.16 3.57z" fill="#ffe4aa" /><path d="m23.17 35.24c.4 4.73.99 7.47 1.28 8.6l-7.03.44.01-.39c.27-1.91 1.14-7.07 2.01-8.43.15-.23.08-.53-.15-.68s-.53-.08-.68.15c-1 1.57-1.85 6.75-2.1 8.38l-2.19-.29c.37-1.32 1.26-4.84 1.69-9.83.45-5.34 4.57-5.73 5.25-5.76.58.24 4.2 1.89 4.61 5.94.18 1.8.62 3.63 1.1 5.24.01.01.01.02.01.03.58 1.9 1.21 3.48 1.55 4.25l-3.09.87c-.25-.94-.88-3.69-1.29-8.61-.02-.27-.3-.47-.53-.44-.27.02-.47.25-.45.53z" fill="#bbe0f6" /><path d="m21.15 27.44c-.86.09-3.98.75-4.34 5.75-.33 4.65-1.02 8.42-1.37 9.97l-1.11-.15c.37-1.32 1.26-4.84 1.69-9.83.44-5.07 4.19-5.67 5.13-5.74z" fill="#a7d6e7" /><path d="m28.54 42.89-.83.24c-.32-.85-1.06-2.69-1.54-4.49v-.03c-.41-1.6-.8-3.44-.95-5.24-.32-3.79-3.06-5.48-3.81-5.88.88.39 4.09 2.09 4.46 5.88.18 1.8.62 3.63 1.1 5.24.01.01.01.02.01.03.59 1.9 1.22 3.47 1.56 4.25z" fill="#cae5f7" /><path d="m32.31 22.69c-.08 1-.62 2.04-1.17 2.55.09-.68.15-1.37.15-2.06 0-.83-.07-1.62-.2-2.38.35-.13.65-.14.83-.02.32.21.46.9.39 1.91z" fill="#f0d299" /><path d="m10.93 23.18c0 .69.06 1.38.15 2.07-.55-.51-1.1-1.55-1.17-2.56-.08-1 .07-1.69.39-1.91.18-.12.47-.11.83.02-.14.76-.2 1.56-.2 2.38z" fill="#f0d299" /><path d="m35.12 38.88c-.11-.01-.21-.02-.32-.02h-4.13c-1.01 0-1.91-.2-2.68-.61-.03-.02-.07-.04-.1-.06-.38-1.27-.73-2.67-.94-4.06 1.96-1.93 3.37-4.69 3.98-7.65 1.2-.38 2.24-2.21 2.35-3.73.1-1.43-.19-2.36-.84-2.8-.42-.29-.96-.33-1.57-.14-.09-.33-.19-.66-.3-.97-.06-.17-.2-.3-.37-.33-10.09-1.74-11.2-5.2-11.21-5.22-.05-.21-.23-.36-.44-.37-.21-.02-.4.1-.49.3-1.46 3.53-6.03 5.05-6.08 5.07-.14.05-.26.16-.31.3-.15.4-.27.82-.36 1.24-.61-.2-1.15-.16-1.58.13-.66.43-.95 1.37-.84 2.8.11 1.54 1.14 3.36 2.36 3.73.58 2.82 1.88 5.46 3.68 7.37-.16 1.63-.37 3.1-.59 4.36-.03.02-.04.04-.08.05-.74.4-1.61.6-2.63.6h-4.1c-.15 0-.29.02-.43.02.5-5 .82-11.86 1.01-22.06.13-7.06 5.97-12.8 13.02-12.8 3.45 0 6.7 1.34 9.14 3.76 2.46 2.42 3.84 5.65 3.87 9.1.13 10.1.45 17.11.98 21.99z" fill="#acb3c6" /><path d="m35.12 38.88c-.11-.01-.21-.02-.32-.02h-1.55c-.32-3.45-.56-7.95-.71-13.84.41-.69.69-1.51.75-2.26.1-1.43-.19-2.36-.84-2.8-.01 0-.01-.01-.02-.01-.01-.98-.03-2.01-.04-3.06-.02-3.45-1.22-6.68-3.36-9.1-1.99-2.27-4.59-3.59-7.37-3.74 3.24.13 6.27 1.45 8.59 3.74 2.46 2.42 3.84 5.65 3.87 9.1.15 10.1.47 17.11 1 21.99z" fill="#bec5da" /><path d="m20.55 4.05c-5.85.34-10.6 5.93-10.72 12.78-.02 1.07-.04 2.12-.06 3.12 0 .01-.01.01-.01.01-.66.43-.95 1.37-.84 2.8.06.74.32 1.55.73 2.24-.17 5.89-.39 10.34-.7 13.86h-1.42c-.15 0-.29.02-.43.02.5-5 .82-11.86 1.01-22.06.13-6.87 5.65-12.48 12.44-12.77z" fill="#9da3b4" /><path d="m30.05 20.56c0-.01-.01-.02-.01-.03-.08-.37-.17-.74-.28-1.08-7.52-1.36-10.24-3.68-11.2-4.98-1.48 2.51-4.38 4.1-6.02 4.69-.42 1.25-.63 2.61-.63 4.03 0 3.42 1.21 6.89 3.2 9.35.84-6 6.02-6.09 6.24-6.09.04 0 .08.02.12.03-.16-.81-.62-1.87-.97-2.49-.13-.24-.04-.54.2-.67.25-.13.54-.04.67.2.13.23 1.11 2.1 1.13 3.44 1.39.77 3.78 2.57 4.28 5.94 2.18-2.46 3.51-6.08 3.51-9.7.01-.94-.08-1.81-.24-2.64zm-11.2-.21c-.03.03-.36.38-1 .73.19.24.32.53.32.86 0 .77-.63 1.39-1.39 1.39-.77 0-1.39-.62-1.39-1.39 0-.07.01-.14.02-.21-.12.01-.24.03-.36.03-.07 0-.15 0-.22-.01-.28-.01-.49-.24-.48-.5.01-.28.23-.49.51-.48 2.17.08 3.23-1.03 3.28-1.08.19-.2.49-.21.69-.02.19.18.2.48.02.68zm8.44 1.4c-.07.01-.15.01-.22.01-.13 0-.25-.02-.36-.03.01.07.02.14.02.21 0 .77-.62 1.39-1.39 1.39s-1.39-.62-1.39-1.39c0-.32.12-.62.32-.86-.64-.34-.97-.7-1-.73-.19-.2-.18-.51.03-.7.2-.18.5-.17.69.03.05.05 1.12 1.16 3.28 1.08.27-.01.5.21.5.48s-.21.5-.48.51z" fill="#f0d299" /><path d="m15.27 31.72c-.06.26-.11.52-.15.81-1.99-2.46-3.2-5.94-3.2-9.35 0-1.42.21-2.78.63-4.03.34-.13.75-.3 1.18-.51-.35 1.27-.77 3.23-.77 4.54 0 3.06.86 6.16 2.31 8.54z" fill="#dfc189" /><path d="m30.3 23.18c0 3.62-1.33 7.24-3.51 9.7-.04-.24-.08-.47-.14-.69 1.62-2.42 2.6-5.71 2.6-9.01 0-.92-.08-1.79-.23-2.62 0-.01-.01-.02-.01-.03-.06-.38-.22-.9-.37-1.3.35.08.73.15 1.11.22.11.34.2.71.28 1.08 0 .01.01.02.01.03.17.83.26 1.7.26 2.62z" fill="#ffe4aa" /><path d="m18.82 19.66c-.2-.19-.5-.18-.69.02-.05.05-1.11 1.16-3.28 1.08-.29-.01-.5.21-.51.48s.21.49.48.5c.07.01.15.01.22.01.13 0 .25-.02.36-.03-.01.07-.02.14-.02.21 0 .77.62 1.39 1.39 1.39.76 0 1.39-.62 1.39-1.39 0-.32-.13-.62-.32-.86.64-.34.97-.7 1-.73.19-.19.18-.49-.02-.68zm-2.05 2.68c-.23 0-.4-.18-.4-.4s.18-.39.4-.39.4.18.4.39c.01.22-.18.4-.4.4z" fill="#4e5292" /><path d="m17.18 21.94c0 .23-.19.4-.4.4-.23 0-.4-.18-.4-.4s.18-.39.4-.39c.21-.01.4.17.4.39z" fill="#d8dfe6" /><path d="m27.26 20.77c-2.16.08-3.23-1.03-3.28-1.08-.19-.2-.49-.21-.69-.03-.21.19-.22.5-.03.7.03.03.36.38 1 .73-.2.24-.32.53-.32.86 0 .77.62 1.39 1.39 1.39s1.39-.62 1.39-1.39c0-.07-.01-.14-.02-.21.12.01.24.03.36.03.07 0 .15 0 .22-.01.28-.01.48-.24.47-.5.01-.29-.22-.5-.49-.49zm-1.92 1.57c-.22 0-.4-.18-.4-.4s.19-.39.4-.39c.22 0 .4.18.4.39 0 .22-.18.4-.4.4z" fill="#4e5292" /><path d="m25.74 21.94c0 .23-.19.4-.4.4-.22 0-.4-.18-.4-.4s.19-.39.4-.39c.22-.01.4.17.4.39z" fill="#d8dfe6" /></g></svg>

            <div className="safety-card-text">
              <h3>Allergies</h3>
              <p>If an individual is allergic to any of the composition of the murineXT consult first with the doctor and should take proper advice from
                healthcare provider.
              </p>
            </div>

          </div>

          <div className="safety-card">
            <svg height="512" viewBox="0 0 38 58" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="004---Pregnant-Woman" fill-rule="nonzero" transform="translate(-1)"><path id="Shape" d="m8.19 51.48c.21711935-.6321605.48118836-1.2472073.79-1.84-.03-.01-.05-.03-.08-.04-4.52-2.56-7.9-7.17-7.9-14.6-.22566764-5.3632583 2.45757859-10.4316123 7.02-13.26l5.98-.74 15.5 8.83c-.1619191 2.8041869.3525292 5.6062152 1.5 8.17 3.241 6.482 5.169 15.589 5.784 18.812.0561122.2931443-.0216505.5960297-.212038.8258877-.1903875.2298581-.4734962.3626589-.771962.3621123h-27.749c-.27798908.0007016-.54372482-.1143445-.733443-.3175327-.18971817-.2031882-.28629517-.476179-.266557-.7534673.14176948-1.8580401.52464889-3.6897432 1.139-5.449z" fill="#2fa8cc" /><path id="Shape" d="m22.43 52.72c.0302975.2627752-.0456076.526768-.2108495.7333204-.1652419.2065523-.4061338.3385557-.6691505.3666796-.9193784.1078173-1.844322.1612436-2.77.16-3.6804766.0375427-7.3148834-.8204381-10.59-2.5.21711935-.6321605.48118836-1.2472073.79-1.84 3.7999279 1.9533681 8.0991434 2.7198408 12.34 2.2.2639721-.0309441.5294037.0444686.7376729.209583.2082693.1651143.3422411.4063457.3723271.670417z" fill="#2980ba" /><path id="Shape" d="m37 31s-13-1-24-7c-1.3692257-1.2505617-3.14603539-1.9612856-5-2 .07185246-1.2891805.83762281-2.437836 2-3 1.08406-.5047895 2.3069704-.6281378 3.47-.35-5.59-1.87-6.08-8.8-1.47-10.65.6515242-.25891016 1.2747835-.58394325 1.86-.97 2.2801619-1.59139076 4.1874608-3.65905299 5.59-6.06.3646126-.60150128 1.0166185-.96920227 1.72-.97h11.78c3.03 0 5.11 3.37 5.05 6 0 5 1 17-1 25z" fill="#fdd7ad" /><path id="Shape" d="m33 23.938c-.2164761.0006557-.4272125-.0695898-.6-.2-2.37-1.777-5.6-2.018-8.45-2.231-1.4410235-.0429317-2.872372-.250957-4.266-.62-.3394023-.1130745-.5926985-.3986287-.6644742-.749097-.0717757-.3504684.0488734-.7126063.3165-.9500001.2676266-.2373937.6415719-.3139775.9809742-.2009029 1.2382462.3093981 2.5062383.4844092 3.782.522 2.969.222 6.663.5 9.5 2.627.3443443.2582582.4847973.7078856.3486833 1.1162278-.136114.4083421-.5182529.6837722-.9486833.6837722z" fill="#f9c795" /><path id="Shape" d="m13 34.16c.697079-1.2935003 2.0312581-2.1168794 3.5-2.16.9681065.0176336 1.8875263.4277486 2.5474398 1.1363072.6599136.7085587 1.0037108 1.6547777.9525602 2.6216928 0 2.818-2.849 4.684-7 8.242-4.151-3.558-7-5.424-7-8.242-.05115056-.9669151.29264661-1.9131341.95256018-2.6216928.65991356-.7085586 1.57933327-1.1186736 2.54743982-1.1363072 1.4687419.0431206 2.802921.8664997 3.5 2.16z" fill="#ff5364" /><path id="Shape" d="m30.05 22.51c-3.6-1.16-7.73-.74-10.05-1.51-2.26-.76-4.47-1.95-6.53-2.35-5.59-1.87-6.08-8.8-1.47-10.65.6515242-.25891016 1.2747835-.58394325 1.86-.97 2.3247484.64684481 4.7269411.97319312 7.14.97 6 0 6-8 6-8h4c-2.6 10.41-1.82 18.28-.95 22.51z" fill="#2fa8cc" /><circle id="Oval" cx="9.5" cy="35" fill="#fb7b76" r="2" /></g></g></svg>
            <div className="safety-card-text">
              <h3>Pregnancy and lactation</h3>
              <p>Murine-XT will offer you important health
                benefits but proper physician will advise you and guide you on taking
                correct dosage.

              </p>
            </div>

          </div>

          <div className="safety-card">
            <svg id="Icons" height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m9 1v16.22a7.809 7.809 0 0 0 -6 7.6v36.18a2.006 2.006 0 0 0 2 2h16a2.006 2.006 0 0 0 2-2v-36.18a7.809 7.809 0 0 0 -6-7.6v-16.22z" fill="#eaeff5" /><path d="m3 24.82v36.18a2.006 2.006 0 0 0 2 2h16a2.006 2.006 0 0 0 2-2v-36.18z" fill="#febd73" /><path d="m54 21h7l-12 14-12-14h7v-20h10z" fill="#ff8680" /><path d="m3 31h20v20h-20z" fill="#565556" /><path d="m27 39 10 14 10-14z" fill="#eaeff5" /><path d="m44.15 43-7.15 10-7.15-10z" fill="#febd73" /><g fill="#383838"><path d="m47.813 39.581a1 1 0 0 0 -.813-1.581h-20a1 1 0 0 0 -.813 1.581l9.813 13.739v8.68h-3a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2h-3v-8.68zm-18.87.419h16.114l-1.429 2h-13.256zm8.057 11.279-5.2-7.279h10.4z" /><path d="m2 24.82v36.18a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-36.18a8.763 8.763 0 0 0 -6-8.355v-14.465a1 1 0 0 0 0-2h-10a1 1 0 0 0 0 2v14.465a8.763 8.763 0 0 0 -6 8.355zm20 36.18a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1-1v-9h18zm0-11h-18v-18h18zm-12.771-31.806a1 1 0 0 0 .771-.974v-15.22h6v15.22a1 1 0 0 0 .771.974 6.771 6.771 0 0 1 5.229 6.626v5.18h-18v-5.18a6.771 6.771 0 0 1 5.229-6.626z" /><path d="m54 0h-10a1 1 0 0 0 -1 1v19h-6a1 1 0 0 0 -.759 1.651l12 14a1 1 0 0 0 1.518 0l12-14a1 1 0 0 0 -.759-1.651h-6v-19a1 1 0 0 0 -1-1zm4.826 22-9.826 11.464-9.826-11.464h4.826a1 1 0 0 0 1-1v-19h8v19a1 1 0 0 0 1 1z" /></g></svg>
            <div className="safety-card-text">
              <h3>Alcohol consumption</h3>
              <p> It is always best to keep alcohol consumption in
                check ,an individual will take the pharmaceutical product safely while
                consuming alcohol in moderation.</p>
            </div>

          </div>

          <div className="safety-card">
            <svg id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><g><g><g><path d="m201.04 286h29.374v218.511h-29.374z" fill="#9eb6f4" /><path d="m260.171 286h29.374v218.511h-29.374z" fill="#9eb6f4" /><path d="m201.04 482.553h29.374v21.957h-29.374z" fill="#6e91ef" /><path d="m260.171 482.553h29.374v21.957h-29.374z" fill="#6e91ef" /><path d="m337.188 288.691.142-32.691c-1.414-15.493-5.158-30.777-12.169-45.169-33.927-96.128 155.438-142.744 147.882 55.725h.004c.036 34.238-7.549 80.655-17.342 101.9-32.323 69.438-130.93 53.346-135.409-11.832-.568-9.514 1.417-18.569 5.401-26.703 6.405-13.078 10.152-27.057 11.491-41.23z" fill="#d15573" /><path d="m453.392 373.038c-26.269 26.639-66.686 28.009-93.18 10.491-11.178-7.392-17.739-20.217-16.866-33.589.46-7.048 2.232-13.979 5.331-20.018 6.404-13.079 10.151-27.057 11.49-41.231.75-26.956.784-52.946-12.028-77.86-15.131-42.874 14.157-75.897 50.579-81.721-39.87-6.746-80.415 22.367-77.515 62.73.394 6.482 1.803 12.866 3.958 18.991 7.011 14.392 10.755 29.676 12.169 45.169.326 25.92.843 49.97-11.634 73.922-7.866 15.362-6.97 35.131 1.229 50.432 13.169 25.133 43.975 36.642 71.171 32.332-.01-.002-.02-.004-.03-.005 21.577-3.264 42.56-15.894 55.326-39.643z" fill="#c21d44" /><path d="m395.139 8.405c-23.723 0-45.481 8.414-62.452 22.42l-11.969 11.719c-14.808 17.192-23.76 39.571-23.76 64.042 0 54.224 43.957 98.181 98.181 98.181s98.181-43.957 98.181-98.181-43.957-98.181-98.181-98.181z" fill="#c4e5f9" /><path d="m410.459 189.447c-54.224 0-98.181-43.957-98.181-98.181 0-23.198 8.056-44.509 21.509-61.311-.364.292-.739.572-1.099.869l-11.969 11.719c-14.808 17.192-23.76 39.571-23.76 64.042 0 54.224 43.957 98.181 98.181 98.181 31.014 0 58.665-14.385 76.658-36.842-16.806 13.464-38.13 21.523-61.339 21.523z" fill="#a4d7f5" /><path d="m440.225 91.053h-30.054v-30.053h-30.063v30.053h-30.054v30.064h30.054v30.053h30.063v-30.053h30.054z" fill="#e08ea2" /><g fill="#d15573"><path d="m380.108 128.784h30.106v22.386h-30.106z" /><path d="m350.054 91.053h22.979v30.063h-22.979z" /></g><path d="m154.545 288.691-.142-32.691c1.414-15.493 5.158-30.777 12.169-45.169 33.927-96.128-155.438-142.744-147.882 55.725h-.004c-.036 34.238 7.549 80.655 17.342 101.9 32.323 69.438 130.93 53.346 135.409-11.832.568-9.514-1.417-18.569-5.401-26.703-6.405-13.078-10.152-27.057-11.491-41.23z" fill="#d15573" /><g><path d="m170.23 341.805c-6.624 31.32-36.431 49.064-67.256 48.204-21.61-.603-40.518-14.963-47.183-35.528-8.316-25.658-11.384-57.682-12.234-87.925h.004c-3.467-91.057 34.518-130.519 73.371-137.285-42.206-7.315-94.482 21.953-98.238 115.069 0-.058-.002-.118-.002-.176-.282 7.465-.286 14.908-.003 22.393h-.004c1.983 45.677 5.654 91.087 29.238 120.621 39.606 49.867 134.8 24.817 122.307-45.373z" fill="#c21d44" /></g><g><g fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="15"><path d="m52.559 225.986c.635-4.96 1.466-9.893 2.438-14.797" /><path d="m58.49 196.605c1.371-4.807 2.916-9.569 4.747-14.222" /></g></g><path d="m259.929 194.298h-29.705v33.697c0 15.467-12.538 28.005-28.005 28.005h-92.047v30h91.183c32.458 0 58.747-26.358 58.661-58.816z" fill="#e8ab4c" /><path d="m259.929 227.389v-219.688h-29.705v219.015c-.03 32.733 26.498 59.284 59.231 59.284h90.734v-30h-91.65c-15.801 0-28.61-12.809-28.61-28.611z" fill="#fcf5be" /><path d="m252.384 226.716v-219.015h-22.161v219.015c-.028 32.733 26.499 59.284 59.232 59.284h22.161c-32.733 0-59.261-26.551-59.232-59.284z" fill="#f8e868" /><path d="m110.171 256h21.447v30h-21.447z" fill="#e1763a" /><path d="m350.171 53.5v15" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="15" /></g></g></g><g><path d="m282.055 435.961h15.006v15.41h-15.006z" /><path d="m500.911 106.424c0-24.501-8.574-48.384-24.145-67.251l-11.573 9.551c13.356 16.185 20.712 36.676 20.712 57.7 0 50.02-40.694 90.714-90.714 90.714s-90.714-40.694-90.714-90.714 40.694-90.714 90.714-90.714c21.722 0 42.735 7.796 59.168 21.951l9.793-11.369c-19.156-16.5-43.647-25.587-68.961-25.587-58.294 0-105.72 47.426-105.72 105.72 0 25.977 9.423 49.791 25.024 68.217-3.398 13.462-2.029 26.991 4.051 39.354 5.076 10.42 8.578 21.961 10.455 34.397h-39.301c-12.278 0-22.267-9.99-22.267-22.268v-226.125h-44.532s.032 228.246.062 229.055c-1.44 10.897-10.785 19.336-22.069 19.336h-38.066c1.876-12.435 5.377-23.972 10.443-34.372 8.916-18.131 7.641-39.031-3.501-57.34-13.129-21.575-37.57-35.31-63.695-35.843-23.27-.748-42.807 6.567-58.157 21.741-33.589 33.197-37.448 94.744-36.76 128.476l15.002-.307c-.639-31.325 2.707-88.243 32.306-117.497 12.309-12.165 28.176-18.02 47.215-17.413 21.136.431 40.782 11.407 51.271 28.643 8.421 13.839 9.462 29.482 2.842 42.942-6.052 12.422-10.118 26.177-12.125 40.969h-29.807v-14.634h-15.006l.006 59.651c.132 16.57 13.649 30.011 30.25 30.011v-15.006c-8.327 0-15.106-6.71-15.238-15.006h29.623c1.762 14.014 5.709 27.364 11.767 39.735 28.269 71.172-84.272 104.663-116.468 32.185-7.941-18.568-14.077-49.167-16.02-79.896l-14.976.949c2.102 33.01 8.52 64.711 17.342 85.18 31.661 72.754 143.755 62.081 149.752-14.556.631-10.582-1.439-20.83-6.154-30.458-5.057-10.327-8.441-21.451-10.102-33.135h30.879v218.59h44.391v-229.795c2.592-1.724 5.066-3.639 7.409-5.725 2.314 2.062 4.769 3.969 7.354 5.697v229.823h44.391v-46.028h-15.006v31.022h-14.379v-207.331c4.588 1.607 9.4 2.726 14.379 3.295v127.997h15.006v-127.547h32.132c-1.662 11.684-5.046 22.809-10.103 33.135-4.716 9.629-6.786 19.877-6.15 30.527 6.049 76.683 118.359 87.199 149.839 14.279 19.414-52.316 26.419-126.174 5.571-188.679 20.055-19.252 32.56-46.315 32.56-76.246zm-248.483-91.418v211.118c0 20.553 16.72 37.274 37.273 37.274h83.032v15.006h-83.045c-27.548 0-50.135-21.627-51.689-48.794.107-1.148-.092-214.603-.092-214.603h14.521zm-24.575 236.816c1.964 4.801 4.473 9.32 7.447 13.488-9.429 8.375-21.656 13.092-34.394 13.092h-83.045v-15.006h83.032c10.597.001 20.167-4.451 26.96-11.574zm-4.952 245.172h-14.379v-204.034c4.926-.567 9.744-1.686 14.379-3.305zm226.133-131.666c-32.209 72.506-144.76 38.949-116.469-32.185 6.055-12.363 10.001-25.706 11.767-39.735h28.37c-.132 8.296-6.911 15.006-15.237 15.006v15.006c16.601 0 30.117-13.441 30.249-30.011h.024v-59.651h-15.006v14.634h-28.572c-2.008-14.792-6.075-28.55-12.136-40.994-3.066-6.235-4.506-12.881-4.31-19.653 18.321 15.229 41.848 24.399 67.478 24.399 22.616 0 43.594-7.142 60.804-19.284 17.952 55.304 8.701 135.848-6.962 172.468z" /><path d="m417.731 158.528v-30.065h30.065v-45.08h-30.065v-30.064h-45.08v30.065h-30.065v45.08h30.065v30.065h45.08zm-60.139-45.07v-15.069h30.065v-30.065h15.069v30.065h30.065v15.069h-30.065v30.065h-15.069v-30.065z" /></g></g></svg>
            <div className="safety-card-text">
              <h3>Renal health</h3>
              <p>It is recommended to take the advice of a health care
                provider before using murine-XT regular kidney function monitoring will be
                suggested for those with renal issues.</p>
            </div>

          </div>

          <div className="safety-card">
            <svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Layer_30" data-name="Layer 30"><circle cx="408" cy="104" fill="#6bc13b" r="88" /><path d="m440 56-48 48-16-16-24 24 40 40 72-72z" fill="#f2f2f2" /><path d="m168 184v-40a16 16 0 0 1 16-16 16 16 0 0 1 16 16v40" fill="#ed3b48" /><path d="m248 184v-40a16 16 0 0 1 16-16 16 16 0 0 1 16 16v40" fill="#ed3b48" /><path d="m447.543 182.637a88.065 88.065 0 0 1 -107.423-22.631l.007-.006h-10.827a155.883 155.883 0 0 0 -49.3 8 155.883 155.883 0 0 1 -49.3 8h-78.132a136.567 136.567 0 0 0 -96.568 40 136.567 136.567 0 0 0 -40 96.568v39.251a48.181 48.181 0 0 0 48.181 48.181 48.175 48.175 0 0 0 15.237-2.473l101.135-33.711a111.984 111.984 0 0 1 21.223-4.846l45.42 3.522q2.135.618 4.251 1.324l8.823 2.941a24.241 24.241 0 0 0 7.661 1.243h9.3a81.536 81.536 0 0 0 77.352-55.753 160.687 160.687 0 0 1 44.95-68.627l39.305-35.375a27.675 27.675 0 0 0 9.162-20.57 27.866 27.866 0 0 0 -.457-5.038z" fill="#7a2429" /><path d="m340.12 160.006.006-.006h-10.826a155.883 155.883 0 0 0 -49.3 8 155.912 155.912 0 0 1 -49.3 8h-78.132a136.569 136.569 0 0 0 -136.568 136.568v17.813a48.154 48.154 0 0 0 55.417 19.146l101.136-33.712a112.138 112.138 0 0 1 21.223-4.846l45.42 3.523q2.135.618 4.251 1.323l8.824 2.942a24.235 24.235 0 0 0 7.66 1.243h9.3a81.537 81.537 0 0 0 77.353-55.752 160.687 160.687 0 0 1 44.95-68.627l4.932-4.44a87.846 87.846 0 0 1 -56.346-31.175z" fill="#ae313a" /><path d="m261.541 172.918a204.032 204.032 0 0 0 -21.541 91.249v44.433a157.728 157.728 0 0 0 1.639 22.676 60.249 60.249 0 0 1 6.361 26.947 60.238 60.238 0 0 1 -3.092 19.052l-4.908 14.725 5.47 16.411a49.279 49.279 0 0 1 2.53 15.589 49.279 49.279 0 0 1 -2.53 15.589 106.6 106.6 0 0 0 -5.47 33.711v6.7a16 16 0 0 1 -16 16 16 16 0 0 1 -16-16v-6.7a106.6 106.6 0 0 0 -5.47-33.709 49.279 49.279 0 0 1 -2.53-15.591 49.279 49.279 0 0 1 2.53-15.589l5.47-16.411-4.908-14.725a60.238 60.238 0 0 1 -3.092-19.052 60.249 60.249 0 0 1 6.361-26.944 157.728 157.728 0 0 0 1.639-22.679v-16.823a83.769 83.769 0 0 0 -8.845-37.466 67.785 67.785 0 0 1 -7.155-30.311 67.785 67.785 0 0 1 7.155-30.311l8.845-17.689h22.7a155.864 155.864 0 0 0 30.839-3.081z" fill="#df9a6d" /><g fill="#fdce9f"><path d="m245.47 439.589a49.292 49.292 0 0 0 0-31.178l-5.47-16.411 4.908-14.725a60.247 60.247 0 0 0 -3.269-46 157.7 157.7 0 0 1 -1.639-22.675v-44.433a204.044 204.044 0 0 1 21.54-91.248 155.854 155.854 0 0 1 -30.84 3.081h-14.7l-.845 1.689a67.781 67.781 0 0 0 0 60.622 83.769 83.769 0 0 1 8.845 37.466v16.823a157.7 157.7 0 0 1 -1.639 22.675 60.247 60.247 0 0 0 -3.269 46l4.908 14.725-5.47 16.411a49.292 49.292 0 0 0 0 31.178 106.6 106.6 0 0 1 5.47 33.711v6.7a16 16 0 0 0 16 16v-6.7a106.6 106.6 0 0 1 5.47-33.711z" /><path d="m261.541 172.918-.001.001h.001z" /></g></g></svg>
            <div className="safety-card-text">
              <h3>Liver health</h3>
              <p>Individuals with existing liver issues or those taking prior
                medications will impact liver function consult with the healthcare expert
                Before starting Murine-XT to align with the specific needs.</p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default MurineXT
